<template>
  <DataTablePage
    mainColumn="name"
    longColumn="remark"
    resource="rbac/role"
    title="角色管理"
    label="角色"
    labelName="name"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth="170"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :createFormValues="createFormValues"
    :columns="columns"
  />
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'

export default {
  name: 'role',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    const hasUpdate = checkActions('/system/role/update')
    const hasDelete = checkActions('/system/role/delete')
    return {
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/role/create')
        }
      }],
      operation: [{
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }],
      tableInitList: ['id', 'name', 'enabled', 'remark'],
      tableFullList: ['id', 'name', 'enabled', 'remark'],
      createList: ['name', 'menuIds', 'enabled', 'remark'],
      updateList: ['name', 'menuIds', 'enabled', 'remark'],
      filterInitList: ['name', 'enabled'],
      filterFullList: ['name', 'enabled', 'remark'],
      createFormValues: {
        name: '',
        menuIds: [],
        enabled: true,
        remark: ''
      },
      columns: {
        id: {
          label: 'ID',
          width: 60
        },
        name: {
          label: '角色名称',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入角色名称'
            }]
          }
        },
        menuIds: {
          label: '权限',
          type: 'multiselect',
          relation: 'menus',
          form: {
            type: 'tree'
          }
        },
        enabled: {
          label: '启用状态',
          width: 120,
          type: 'select',
          sort: true,
          relation: 'enabled',
          filter: {
            type: 'select'
          },
          form: {
            type: 'select'
          }
        },
        remark: {
          label: '备注',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            large: true,
            rules: [{
              type: 'maxLength',
              value: 120,
              message: '字数不能大于120个字'
            }]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Role.vue?73819140